// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'
import { updateBulkEditState } from 'redux/modules/bulkEdit'
import togglePathsSitesHighlight from './togglePathsSitesHighlight'

const togglePathHighlight = pathId => (dispatch, getState) => {
  const {
    bulkEdit,
    form,
  } = getState()

  const { bulkMode } = form[BULK_EDITS_FILTER].values

  // if we're in site bulk mode, when a path highlight is toggled, it should
  // actually toggle that path's sites instead.
  if (bulkMode === 'site') {
    return dispatch(togglePathsSitesHighlight(pathId))
  }

  const prevHighlighted = bulkEdit.get('highlightedPathIds')

  // look for the index of this pathId in the current list of highlightedPaths
  const indexInSelectedPaths = prevHighlighted.indexOf(pathId)

  // if the pathId wasn't in the list, then add it
  // otherwise remove the thing
  const highlightedPathIds = (
    !~indexInSelectedPaths
      ? prevHighlighted.push(pathId)
      : prevHighlighted.delete(indexInSelectedPaths)
  )

  dispatch(updateBulkEditState({ highlightedPathIds }))
}

export default togglePathHighlight
